const RECAPTCHA_SCORE_THRESHOLD = 0.5;

export function loadRecaptchaV3Script(siteKey) {
  return new Promise((resolve, reject) => {
    if (window.grecaptcha && window.grecaptcha.ready) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
    script.async = true;
    script.defer = true;
    
    script.onload = () => {
      window.grecaptcha.ready(() => {
        resolve();
      });
    };
    
    script.onerror = () => {
      reject(new Error('Failed to load reCAPTCHA script'));
    };
    
    document.head.appendChild(script);
  });
}

export function executeRecaptchaV3(siteKey, action = 'contact_form') {
  return new Promise((resolve, reject) => {
    if (!window.grecaptcha || !window.grecaptcha.execute) {
      reject(new Error('reCAPTCHA not loaded'));
      return;
    }

    window.grecaptcha.execute(siteKey, { action })
      .then(token => {
        resolve(token);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export async function verifyRecaptchaToken(token, secretKey, expectedAction = 'contact_form') {
  try {
    const response = await fetch('https://www.google.com/recaptcha/api/siteverify', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: new URLSearchParams({
        secret: secretKey,
        response: token,
      }),
    });

    const data = await response.json();

    if (!data.success) {
      return {
        success: false,
        score: 0,
        action: null,
        errors: data['error-codes'] || ['verification-failed'],
        needsV2Fallback: true
      };
    }

    const score = data.score || 0;
    const action = data.action || '';
    const needsV2Fallback = score < RECAPTCHA_SCORE_THRESHOLD;

    return {
      success: true,
      score,
      action,
      expectedAction,
      actionMatches: action === expectedAction,
      needsV2Fallback,
      errors: []
    };
  } catch (error) {
    return {
      success: false,
      score: 0,
      action: null,
      errors: ['network-error'],
      needsV2Fallback: true
    };
  }
}

export function isScoreAboveThreshold(score) {
  return score >= RECAPTCHA_SCORE_THRESHOLD;
}
